import { React, useState, useEffect } from "react";
import AdminDashboardLayout from "../../layout/AdminDashboardLayout";
import { DashboardWrapper } from "../dashboard/dashboard.styled";
import AccountTable from "./Sections/AccountTable";
import { fetchTableData } from "../apprenticeship/utils";
import { AccountHeaders } from "./data";
import { Outlet, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Backdrop, CircularProgress } from "@mui/material";
import { getFilteredTableData } from "../../utils/Utils";
import { IntroductionHeader } from "../dashboard/Dashboard";

function Account() {
	const { id } = useParams();
	const [TableData, setTableData] = useState([]);
	const [loading, setLoading] = useState(false);
    const [dateFilter, setDateFilter] = useState("6 Months");
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
		handleDateFilterChange({ target: { value: dateFilter } });
	}, [TableData]);

	useEffect(() => {
		// If current page is AF Dashboard, fetch data
		// console.log(id)
		if (!id) {
			setLoading(true);
			getTableData();
		}
	}, []);


    const handleDateFilterChange = (e) => {
		// Filter TableData based on date - All Time, Today, Last 7 days, Last 30 days, Last 6 months, Last 12 months
		let filteredTableData = getFilteredTableData(e.target.value, TableData);
		setDateFilter(e.target.value);
		setFilteredData(filteredTableData);
	};

    const getTableData = async () => {
		const data = await fetchTableData("submitted", "all");
		if (data) {
			setLoading(false);
			setTableData(data);
			// console.log(data)
		} else {
			setLoading(false);
			setTableData([]);
			toast.error("Error fetching  data!");
		}
	};

	return (
		<AdminDashboardLayout>
			<DashboardWrapper>

				{id ? (
					<Outlet context={[loading, setLoading]} />
				) : (
                    <>
                    <IntroductionHeader/>
					<AccountTable headCells={AccountHeaders} TableData={filteredData} 
                    // allData={TableData}
					dateFilter={dateFilter}
					handleDateFilterChange={handleDateFilterChange}/>
                    </>
				)}
			</DashboardWrapper>
			{loading && (
				<Backdrop
					sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={loading}
				>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</AdminDashboardLayout>
	);
}

export default Account;
